import Text from "./Text";

const NavLink = props => {
    return (
        <Text style={{paddingLeft:20, color:props.active ? props.theme.Magenta : props.theme.Audi, cursor:'pointer'}} onClick={() => props.navigate(props.location)}>{props.text}</Text>
    )
}

export default NavLink;